import { PRICE_SHEETS } from "../constants/action-types";
import { uploadActions } from "./base-upload-reducers";

export const priceSheetsUpload = uploadActions(PRICE_SHEETS);
